import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  dialog: css`
    z-index: 1000;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  `,
  content: css`
    width: 520px;
    display: flex;
    flex-direction: column;
    margin-bottom: 100px;
    padding: 16px 24px;
    min-width: 520px;

    & > button:first-of-type {
      width: 20px;
      height: 20px;

      & svg {
        width: 16px;
        height: 16px;
      }
    }
  `,
  title: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
  `,
  body: css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;
    width: 100%;
  `,
  selectWrapper: css`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  `,
  select: css`
    z-index: 1000;
    width: calc(520px - 48px);

    & > div {
      overflow: unset;
    }
  `,
  footerMessageContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
  `,
  errorMessage: css`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  `,
  endIcon: css`
    display: flex;
    align-items: center;
    gap: 5px;
  `,
} satisfies Styles<{}>;

export const useStyles = withStyles(styles);
